import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class AuctionClerkModel extends BaseModel {
  clerk = null;
  allSelected = false;
  pdf_type = 'default';

  static TRANSLATABLE_FIELDS = [];

  rules = {
    pdf_type: 'required'
  };

  attributeLabels = {
    clerk: i18n.t('Clerk'),
    allSelected: i18n.t('Select All'),
    pdf_type: i18n.t('PDF Type'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(AuctionClerkModel);
